import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ModalController, LoadingController, ToastController } from 'ionic-angular';
import { SpeakerData } from '../../providers/speaker';
import { AuthData } from '../../providers/auth';
import { Tracking } from '../../providers/tracking';
import { EventData } from '../../providers/event';
import { Translate } from '../../providers/translate';
import { EventCommentPage } from '../event-comment/event-comment';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-event-resource',
  templateUrl: 'event-resource.html'
})
export class EventResourcePage {

  obs1: any;
  resources: any;
  type: any;
  speakerId: any;
  client: any;
  title: any;
  event: any;
  textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, public speakerProvider: SpeakerData, public actionSheetCtrl: ActionSheetController, public auth: AuthData, public modalCtrl: ModalController, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public track: Tracking, public eventProvider: EventData, translate: Translate) {
    translate.translateGroup(['Más opciones', 'Agregar a favoritos', 'Compartir', 'Cancelar',"Debe iniciar sesión antes de continuar", "Recurso guardado en favoritos", 'Comentarios Recurso']).then(result => {
      this.textTranslate = result;
    });

    this.resources = this.params.get('resources');
    this.title = this.params.get('title');
    this.speakerId = this.params.get('speakerId');
    this.client = this.params.get('client');
    this.type = this.params.get('type') || 'resource';
    this.event = this.params.get('event');

    if (this.speakerId) {
      this.obs1 = this.speakerProvider.getResources(this.client, this.speakerId).subscribe((data: any) => {
        this.resources = data;

        this.resources.forEach((resource: any) => {
          this.speakerProvider.getResourceMyLike(this.client, this.speakerId, resource.id)
          .then((result: any) => {
            if (result.val()) {
              resource.likeBloqued = 1;
            } else {
              resource.likeBloqued = -1;
            }
          });
        });
      });
    } else {
      // this.obs1 = this.speakerProvider.getResourcesActivity(this.client, this.event).subscribe((data: any) => {
      //   this.resources = data;
      // });
    }
  }

  moreOptions(resource) {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.textTranslate['Más opciones'],
      buttons: [
        {
          icon: 'heart',
          text: this.textTranslate['Agregar a favoritos'],
          handler: () => {
            this.favorite(resource);
          }
        },
        {
          icon: 'md-share',
          text: this.textTranslate['Compartir'],
          handler: () => {
            console.log('Archive clicked');
          }
        },
        {
          icon: 'close',
          text: this.textTranslate['Cancelar'],
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  favorite(resource){
    if (this.auth.getUser().isAnonymous) {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event})
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        toast.present();
    } else {
      let loading = this.loadingCtrl.create();
      loading.present();

      this.speakerProvider.pushResourceFavorite(this.client, this.speakerId, resource)
      .then(() => {
        // Increase counter dashboard
        this.eventProvider.setTransactionDashboard(this.client, this.event, 'numFavorites');

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Recurso guardado en favoritos"],
          duration: 3000,
          dismissOnPageChange: true
        });
        loading.dismiss();
        toast.present();
      })
      .catch(error => {
        let toast = this.toastCtrl.create({
          message: error,
          duration: 3000,
          dismissOnPageChange: true
        });
        loading.dismiss();
        toast.present();
      });
    }
  }

  sendLike(resource) {
    this.speakerProvider.pushLikeResource(this.client, this.speakerId, resource.id)
    .then(result => {
      resource.likeBloqued = 1;
      // Increase counter dashboard
      this.eventProvider.setTransactionDashboard(this.client, this.event, 'numLikesResource');

      let toast = this.toastCtrl.create({
        message: this.textTranslate["Gracias por el Like"],
        duration: 2000,
        dismissOnPageChange: true
      });
      toast.present();
    })
  }

  viewComments(resource) {
    this.navCtrl.push(EventCommentPage, {type: this.type, token: this.speakerId, token2: resource.id, title: this.textTranslate['Comentarios Recurso'], client: this.client, event: this.event});
  }

  viewResource(resource) {
    if (this.speakerId) {
      this.track.saveTrackingResource(this.client, this.event.id, this.speakerId, resource.id)
      .then(() => {
          window.open(
            resource.url,
            '_blank'
          );
      })
      .catch((error) => {
        this.track.trackError('Resource', error);
      });
    } else {
      window.open(
        resource.url,
        '_blank'
      );
    }
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    console.log('Se eliminan los observable de resources', 'obs1');
    this.obs1.unsubscribe();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-resource/event-resource.ts